"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m20.755 16.341-2.756-.688-.203-.817a5.242 5.242 0 0 0 1.401-2.778c.43-.154.755-.539.814-1.014l.185-1.478a1.24 1.24 0 0 0-.701-1.273l.061-1.25.243-.244c.45-.478.823-1.293.055-2.464C19.273 3.449 18.296 3 16.945 3c-.539 0-1.8 0-2.961.824a.5.5 0 0 0 .578.815c.795-.564 1.651-.64 2.384-.64.992 0 1.688.297 2.072.883.438.669.273.998.064 1.22l-.369.37a.499.499 0 0 0-.146.329l-.09 1.85a.498.498 0 0 0 .493.524.236.236 0 0 1 .178.082.23.23 0 0 1 .057.186l-.185 1.479c-.014.119-.117.209-.273.209a.5.5 0 0 0-.498.461 4.17 4.17 0 0 1-1.342 2.713.5.5 0 0 0-.151.493l.347 1.389c.045.179.184.32.364.364l3.047.761A3.279 3.279 0 0 1 22.963 20l-3.463-.002V21l3.999-.003a.5.5 0 0 0 .5-.5 4.276 4.276 0 0 0-3.244-4.156Zm-6 0-2.756-.688-.11-.443c1.887-.337 2.865-.907 2.91-.933a.502.502 0 0 0 .052-.824c-.013-.01-1.285-1.082-1.285-4.779 0-3.275-.79-4.935-2.348-4.935h-.166C10.523 3.238 10.084 3 9 3 7.57 3 4.435 4.429 4.435 8.674c0 3.697-1.272 4.769-1.278 4.774a.498.498 0 0 0 .042.828c.044.027 1.014.6 2.913.937l-.11.44-2.756.689A4.277 4.277 0 0 0 0 20.5a.498.498 0 0 0 .5.5l17-.003a.5.5 0 0 0 .5-.5 4.278 4.278 0 0 0-3.245-4.156ZM1.039 19.998a3.281 3.281 0 0 1 2.45-2.687l3.047-.761a.502.502 0 0 0 .364-.364l.315-1.261a.5.5 0 0 0-.417-.616c-1.178-.164-2.023-.435-2.527-.635.497-.72 1.165-2.208 1.165-5C5.435 4.832 8.294 4 9 4c.863 0 1.034.133 1.494.593a.504.504 0 0 0 .354.146h.37c.857 0 1.348 1.435 1.348 3.935 0 2.79.667 4.278 1.164 4.999-.507.2-1.353.47-2.527.635a.497.497 0 0 0-.416.616l.315 1.263c.045.179.184.32.364.364l3.047.761A3.279 3.279 0 0 1 16.962 20l-15.923-.002Z",
    clipRule: "evenodd"
  })]
});